/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".clearfix[_ngcontent-%COMP%]::after{content:\"\";clear:both;display:table}.mat-icon[_ngcontent-%COMP%]{color:gray}"];
export { styles as styles };
